// Vehicle types
export const BUS = 'Bus';
export const SEDAN = 'Sedan';
export const VAN = 'Van';
export const TRUCK = 'Truck';
export const BATTERY = 'Battery';

// CO2 combustion interna (gCO2/km)
export const CO2_BY_TYPES = {
  [SEDAN]: 127.9,
  [VAN]: 158,
  [BUS]: 1300,
  [TRUCK]: 1064,
};

// Factor de emision del SEN (g/kwh)
export const FE_SEN = 408.7;
